'use client';

import { Box, Typography } from '@mui/material';
import MarketingInteriorLayout, {
  MARKETING_FORM_COLUMN_INNER_SX,
  MARKETING_FORM_COLUMN_SX,
  MARKETING_FORM_HERO_COLUMN_SX,
} from '@/components/home-landing/MarketingInteriorLayout';
import TradePartnerForm from '@/components/TradePartnerForm';
import {
  FORM_PAGE_DESKTOP_BP,
  heroTextLegibility,
} from '@/components/design-studio/design-studio-glass';

const PAGE_COPY = {
  title: 'Become an Authorized Dealer Partner',
  paragraphs: [
    "NIICO has partnered with a select circle of designers, builders, and showrooms who hold craftsmanship to the same exacting standard we do. It's a relationship built on more than transactions, it's a shared belief that the details are what elevate a space from finished to exceptional.",
    "If that resonates, we'd love to start a conversation.",
  ],
};

const TRADE_PARTNER_FORM_GRID_SX = {
  width: '100%',
  maxWidth: { [FORM_PAGE_DESKTOP_BP]: 1200, xl: 1280 },
  mx: 'auto',
  px: { xs: 2, sm: 3, [FORM_PAGE_DESKTOP_BP]: 2, xl: 3 },
  gap: { xs: 4, [FORM_PAGE_DESKTOP_BP]: 3 },
};

export default function TradePartnerPage() {
  return (
    <MarketingInteriorLayout heroBackground formGrid formGridSx={TRADE_PARTNER_FORM_GRID_SX}>
      <Box
        sx={{
          ...MARKETING_FORM_HERO_COLUMN_SX,
          textAlign: { xs: 'center', [FORM_PAGE_DESKTOP_BP]: 'left' },
        }}
      >
        <Typography
          component="h1"
          sx={{
            ...heroTextLegibility,
            fontWeight: 600,
            fontSize: {
              xs: 'clamp(1.75rem, 5vw, 2.5rem)',
              [FORM_PAGE_DESKTOP_BP]: '2.75rem',
              xl: '3.25rem',
            },
            lineHeight: 1.15,
            letterSpacing: '-0.02em',
            mb: { xs: 2, [FORM_PAGE_DESKTOP_BP]: 1.25 },
          }}
        >
          {PAGE_COPY.title}
        </Typography>
        {PAGE_COPY.paragraphs.map((paragraph, index) => (
          <Typography
            key={paragraph}
            component="p"
            sx={{
              ...heroTextLegibility,
              fontWeight: 400,
              fontSize: { xs: '1rem', [FORM_PAGE_DESKTOP_BP]: '1.0625rem' },
              lineHeight: { xs: 1.65, [FORM_PAGE_DESKTOP_BP]: 1.55 },
              maxWidth: { [FORM_PAGE_DESKTOP_BP]: 420, xl: 480 },
              mx: { xs: 'auto', [FORM_PAGE_DESKTOP_BP]: 0 },
              mt: index === 0 ? 0 : 2,
              opacity: 0.95,
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>

      <Box sx={MARKETING_FORM_COLUMN_SX}>
        <Box sx={MARKETING_FORM_COLUMN_INNER_SX}>
          <TradePartnerForm variant="glass" />
        </Box>
      </Box>
    </MarketingInteriorLayout>
  );
}
